<!-- Filtro avanzado flotante superior -->
<app-advanced-filter #advFilter [fields]="advancedFilterFields" [showTrigger]="false"
    (filtersChange)="activeAdvancedFilters.set($event)">
</app-advanced-filter>

<!-- Cabecera estandarizada responsive -->
<app-page-header
    title="Gestión de Reembolsos"
    mobileTitle="Reembolsos"
    icon="fas fa-hand-holding-heart"
    optionsLabel="Exportar"
    optionsIcon="fa fa-cog"
    [hasOptions]="true">
    <div headerOptions>
        @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
        <a (click)="exportExcel()" class="dropdown-item">
            <i class="fa fa-file-excel fa-fw me-2 text-success"></i> Exportar Cartola Excel
        </a>
        }
        @if (perm.hasCurrentAction('ACCOUNT_REIMBURSEMENTS_UCH')) {
        <div role="separator" class="dropdown-divider"></div>
        <a (click)="openReimbursementExportModal(reimbursementExportModal)" class="dropdown-item">
            <i class="fas fa-file-invoice-dollar fa-fw me-2 text-primary"></i> Aasinet - Exportador Reembolsos
        </a>
        }
    </div>
</app-page-header>

<app-mobile-footer [visible]="appSettings.isMobile()">
    <ng-select [items]="statuses" bindLabel="name" bindValue="slug"
        class="mobile-footer-search"
        [ngModel]="selectedStatus()"
        (ngModelChange)="selectedStatus.set($event); loadReimbursements()"
        [clearable]="false"
        [dropdownPosition]="'top'"
        placeholder="Estado">
    </ng-select>
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
        [class.btn-outline-primary]="advFilter.activeFiltersCount() > 0"
        (click)="advFilter.toggleOpen()">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (advFilter.activeFiltersCount() > 0) {
            <span class="badge bg-primary ms-1">{{ advFilter.activeFiltersCount() }}</span>
        }
    </button>
</app-mobile-footer>

@if (!appSettings.isMobile()) {
    <!-- Panel superior de filtros Desktop -->
    <div class="panel p-3 mb-3 border-0 shadow-sm position-relative">
        <div class="row align-items-end g-3">
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Desde</label>
                <ng-select [items]="periods()" bindLabel="displayName" bindValue="id"
                    [ngModel]="selectedPeriodStartId()"
                    (ngModelChange)="onPeriodStartChange($event)" [clearable]="false"
                    placeholder="Desde">
                </ng-select>
            </div>
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Hasta</label>
                <ng-select [items]="filteredEndPeriods" bindLabel="displayName" bindValue="id"
                    [ngModel]="selectedPeriodEndId()" 
                    (ngModelChange)="selectedPeriodEndId.set($event); loadReimbursements()"
                    [clearable]="false" placeholder="Hasta">
                </ng-select>
            </div>
            <div class="col-md-3">
                <label class="form-label fw-bold small text-uppercase text-muted">Contabilización</label>
                <ng-select [items]="accountedFilters" bindLabel="name" bindValue="slug"
                    [ngModel]="selectedAccounted()"
                    (ngModelChange)="selectedAccounted.set($event); loadReimbursements()" [clearable]="false"
                    placeholder="Contabilización">
                </ng-select>
            </div>
            @if (!authService.isUserRole()) {
            <div class="col-md-3">
                <label class="form-label fw-bold small text-uppercase text-muted">Entidad</label>
                <ng-select [items]="allEntities()" bindLabel="name" bindValue="code" 
                    [ngModel]="selectedEntityCode()"
                    (ngModelChange)="selectedEntityCode.set($event); loadReimbursements()" [multiple]="true"
                    placeholder="Todas las Entidades">
                </ng-select>
            </div>
            }
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Estado</label>
                <ng-select [items]="statuses" bindLabel="name" bindValue="slug" 
                    [ngModel]="selectedStatus()"
                    (ngModelChange)="selectedStatus.set($event); loadReimbursements()" [clearable]="false"
                    placeholder="Filtrar por estado">
                </ng-select>
            </div>
        </div>
    </div>
}

@if (!appSettings.isMobile()) {
    <!-- Tabla Desktop -->
    <div class="panel p-3 mb-3 border-0 shadow-sm">
        <div class="col-12 table-data mb-3">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th class="text-uppercase align-middle">
                            <div class="d-inline-flex align-items-center gap-1">
                                <button type="button" class="filter-table-btn" (click)="advFilter.toggleOpen()" title="Filtros avanzados">
                                    <i class="fas fa-filter" [class.text-primary]="advFilter.activeFiltersCount() > 0"></i>
                                    @if(advFilter.activeFiltersCount() > 0) {
                                        <span class="filter-count-badge">{{ advFilter.activeFiltersCount() }}</span>
                                    }
                                </button>
                                <span>Entidad</span>
                            </div>
                        </th>
                        <th class="text-center text-uppercase">Contabilizado</th>
                        <th class="text-uppercase">Socio</th>
                        <th class="text-center text-uppercase">Tipo</th>
                        <th class="text-center text-uppercase">Periodo</th>
                        <th class="text-end text-uppercase">Monto</th>
                        <th class="text-center text-uppercase">Estado</th>
                        <th class="text-end text-uppercase">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @if(isLoading()) {
                        @for(i of [1,2,3,4,5,6]; track $index) {
                        <tr class="placeholder-glow">
                            <td class="align-middle"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                            <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            <td class="align-middle"><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                            <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            <td class="align-middle text-end"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                            <td class="align-middle text-center"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                            <td class="align-middle text-end"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                        </tr>
                        }
                    } @else {
                        @for(item of filteredReimbursements(); track item.id) {
                            <tr>
                                <td class="align-middle">{{ item.entityCode }}</td>
                                <td class="text-center align-middle">
                                    @if(item.accountedAt) {
                                        <span class="badge bg-success" [title]="item.accountedAt">Contabilizado</span>
                                    } @else {
                                        <span class="badge bg-secondary">No</span>
                                    }
                                </td>
                                <td class="align-middle">{{ item.party?.names }}</td>
                                <td class="text-center align-middle">
                                    <span class="badge" [ngClass]="item.reimbursementType === 'CLAIM' ? 'bg-danger' : 'bg-primary'">
                                        {{ item.reimbursementType }}
                                    </span>
                                </td>
                                <td class="text-center align-middle">
                                    {{ item.year }}/{{ item.period | number:'2.0-0' }}
                                </td>
                                <td class="align-middle text-end font-monospace">
                                    ${{ item.amount | number:'1.0-0':'es-CL' }}
                                </td>
                                <td class="text-center align-middle">
                                    <span class="badge border" 
                                        [ngClass]="{
                                            'bg-light text-warning border-warning': item.statusSlug === 'PENDING_PAYMENT' || item.statusSlug === 'PENDING_REIMBURSEMENT',
                                            'bg-light text-info border-info': item.statusSlug === 'REVIEWING',
                                            'bg-light text-secondary border-secondary': item.statusSlug === 'PENDING',
                                            'bg-light text-success border-success': item.statusSlug === 'PAID' || item.statusSlug === 'REIMBURSED',
                                            'bg-light text-danger border-danger': item.statusSlug === 'FAILED'
                                        }">
                                        {{ item.statusSlug === 'PENDING_REIMBURSEMENT' ? 'Proceso de reembolso' :
                                           item.statusSlug === 'REIMBURSED' ? 'Reembolsado' :
                                           item.statusSlug === 'PENDING_PAYMENT' ? 'Pendiente de pago' :
                                           item.statusSlug === 'REVIEWING' ? 'En revisión' : 
                                           item.statusSlug === 'PENDING' ? 'Pendiente' : 
                                           item.statusSlug === 'PAID' ? 'Pagado' : 'Fallido' }}
                                    </span>
                                </td>
                                <td class="text-end align-middle">
                                    @if (perm.hasCurrentAction('EXPORT_PDF')) {
                                    <button class="btn btn-xs btn-outline-secondary me-1" (click)="openPreview(item, preview)" [disabled]="isGeneratingPdf()" title="Generar PDF">
                                        @if (isGeneratingPdf()) {
                                            <span class="spinner-border spinner-border-sm"></span>
                                        } @else {
                                            <i class="fas fa-file-pdf"></i>
                                        }
                                    </button>
                                    }
                                    @if(item.statusSlug === 'PAID' || item.statusSlug === 'REIMBURSED') {
                                        <button class="btn btn-xs btn-outline-info" (click)="viewReceipt(item, preview)" title="Ver Comprobante">
                                            <i class="fas fa-eye"></i>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    }

                    @if(!isLoading() && hasLoadedPeriod() && filteredReimbursements().length === 0) {
                        <tr>
                            <td colspan="8" class="text-center p-5">
                                <div class="py-5">
                                    <i class="fas fa-receipt fa-4x text-light mb-3"></i>
                                    <h4 class="text-muted fw-normal">No hay reembolsos para este periodo</h4>
                                    <p class="text-muted small mb-0">Modifica los filtros de periodo o estado en la parte superior.</p>
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
                <tfoot>
                    <tr>
                        @if(!isLoading() && filteredReimbursements().length > 0) {
                            <td colspan="5" style="text-align: right; font-weight: bold;">TOTAL DEL PERIODO:</td>
                            <td style="text-align: right; font-weight: bold; font-family: monospace;">
                                ${{ totalAmount() | number:'1.0-0':'es-CL' }}
                            </td>
                            <td colspan="2"></td>
                        }
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
} @else {
    <!-- Vista Movil: Tarjetas ListCard -->
    <div class="col-12 mobile-reimbursement-container">
        <!-- Barra de cabecera movil -->
        <div class="d-flex justify-content-between align-items-center mb-2 px-1">
                <span class="small text-muted fw-bold text-uppercase">
                    Reembolsos @if(!isLoading()) { ({{ filteredReimbursements().length }}) }
                </span>
                @if (!isLoading() && filteredReimbursements().length > 0) {
                    <span class="small fw-bold font-monospace">${{ totalAmount() | number:'1.0-0':'es-CL' }}</span>
                }
            </div>

        <!-- Contenedor con scroll para tarjetas -->
        <div class="mobile-cards-scroll">
            @if(isLoading()) {
                @for(i of [1,2,3,4]; track $index) {
                    <app-list-card [isLoading]="true"></app-list-card>
                }
            } @else {
                @for(item of filteredReimbursements(); track item.id) {
                    <app-list-card>
                        <div cardTitle class="fw-bold text-dark text-truncate">
                            {{ item.party?.names || 'Sin socio' }}
                        </div>
                        <div cardBadge>
                            <span class="badge bg-light text-dark border">{{ item.entityCode }}</span>
                            <span class="badge ms-1" [ngClass]="item.reimbursementType === 'CLAIM' ? 'bg-danger' : 'bg-primary'">
                                {{ item.reimbursementType }}
                            </span>
                        </div>

                        <!-- Acciones contextuales -->
                        <div cardActions>
                            @if (perm.hasCurrentAction('EXPORT_PDF')) {
                            <button class="btn btn-xs btn-outline-secondary me-1" (click)="openPreview(item, preview)" [disabled]="isGeneratingPdf()" title="Generar PDF">
                                @if (isGeneratingPdf()) {
                                    <span class="spinner-border spinner-border-sm"></span>
                                } @else {
                                    <i class="fas fa-file-pdf"></i>
                                }
                            </button>
                            }
                            @if(item.statusSlug === 'PAID' || item.statusSlug === 'REIMBURSED') {
                                <button class="btn btn-xs btn-outline-info" (click)="viewReceipt(item, preview)" title="Ver Comprobante">
                                    <i class="fas fa-eye"></i>
                                </button>
                            }
                        </div>

                        <div class="row g-1">
                            <div class="col-6">
                                <i class="fa fa-calendar me-1 text-muted"></i>
                                <span>{{ item.year }}/{{ item.period | number:'2.0-0' }}</span>
                            </div>
                            <div class="col-6 text-end">
                                <span class="badge border" 
                                    [ngClass]="{
                                        'bg-light text-warning border-warning': item.statusSlug === 'PENDING_PAYMENT' || item.statusSlug === 'PENDING_REIMBURSEMENT',
                                        'bg-light text-info border-info': item.statusSlug === 'REVIEWING',
                                        'bg-light text-secondary border-secondary': item.statusSlug === 'PENDING',
                                        'bg-light text-success border-success': item.statusSlug === 'PAID' || item.statusSlug === 'REIMBURSED',
                                        'bg-light text-danger border-danger': item.statusSlug === 'FAILED'
                                    }">
                                    {{ item.statusSlug === 'PENDING_REIMBURSEMENT' ? 'Proceso reembolso' :
                                       item.statusSlug === 'REIMBURSED' ? 'Reembolsado' :
                                       item.statusSlug === 'PENDING_PAYMENT' ? 'Pendiente pago' :
                                       item.statusSlug === 'REVIEWING' ? 'En revisión' : 
                                       item.statusSlug === 'PENDING' ? 'Pendiente' : 
                                       item.statusSlug === 'PAID' ? 'Pagado' : 'Fallido' }}
                                </span>
                            </div>
                            @if(item.accountedAt) {
                                <div class="col-12 mt-1">
                                    <span class="badge border bg-light text-success border-success" [title]="item.accountedAt">Contabilizado</span>
                                </div>
                            }
                        </div>

                        <div cardExtra>
                            <span class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Reembolso</span>
                        </div>
                        <div cardAmount class="fw-bold font-monospace fs-14">
                            ${{ item.amount | number:'1.0-0':'es-CL' }}
                        </div>
                    </app-list-card>
                }

                @if(hasLoadedPeriod() && filteredReimbursements().length === 0) {
                    <div class="card border-0 shadow-sm p-4 text-center">
                        <i class="fas fa-receipt fa-3x text-muted opacity-50 mb-2"></i>
                        <h6 class="text-muted mb-1">No hay reembolsos para este periodo</h6>
                        <small class="text-muted">Modifica los filtros o selecciona otro periodo.</small>
                    </div>
                }
            }
        </div>

    </div>
}

    <!-- Modal de Previsualización (Estilo Billing) -->
    <ng-template #preview let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Previsualización de Documento</h4>
            <div class="ms-auto d-flex align-items-center">
                @if (previewType === 'pdf' && perm.hasCurrentAction('EXPORT_PDF')) {
                    <button type="button" class="btn btn-success btn-sm me-2" (click)="downloadPreviewPdf()">
                        <i class="fas fa-download me-1"></i> Descargar PDF
                    </button>
                }
                <a [href]="previewType === 'pdf' ? pdfSrc : imgSrc" class="btn btn-outline-success btn-sm me-2" target="_blank">
                    <i class="fas fa-external-link-alt me-1"></i> Abrir en nueva pestaña
                </a>
                <button type="button" class="btn-close" (click)="d('Cross click')"></button>
            </div>
        </div>
        <div class="modal-body p-0 text-center bg-light">
            <iframe *ngIf="previewType === 'pdf' && pdfSrc" [src]="pdfSrc" width="100%" height="750px" style="border: none;"></iframe>
            <div *ngIf="previewType === 'image' && imgSrc" class="p-3">
                <img [src]="imgSrc" class="img-fluid rounded border shadow-sm" style="max-height: 730px; object-fit: contain;">
            </div>
        </div>
    </ng-template>

    <!-- Modal de Exportación y Contabilización de Reembolsos -->
    <ng-template #reimbursementExportModal let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-hand-holding-heart me-2"></i> Exportar y Contabilizar Reembolsos</h5>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="alert alert-info d-flex align-items-center mb-3 py-2 px-3">
                <i class="fas fa-info-circle me-2"></i>
                <div>Se muestran los <strong>reembolsos pagados</strong> pendientes de contabilizar del periodo cerrado. Al exportar, se generará la planilla ASINET y quedarán marcados como contabilizados.</div>
            </div>

            <div class="mb-3">
                <label class="form-label small text-muted mb-1">Periodo cerrado</label>
                <ng-select
                    [items]="closedPeriods()"
                    bindLabel="displayName"
                    bindValue="id"
                    [ngModel]="asinetPeriodId()"
                    (ngModelChange)="onAsinetPeriodChange($event)"
                    [clearable]="false"
                    placeholder="Seleccione periodo cerrado">
                </ng-select>
            </div>

            @if(isPendingReimbursementsLoading()) {
                <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="text-muted small mt-2">Cargando pagos pendientes...</p>
                </div>
            } @else {
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle mb-0">
                        <thead class="table-light">
                            <tr>
                                <th style="width: 110px;">Fecha Pago</th>
                                <th style="width: 120px;">N° Solicitud</th>
                                <th>Beneficiario</th>
                                <th style="width: 100px;">Entidad</th>
                                <th class="text-end" style="width: 150px;">Monto Neto</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(item of pendingReimbursements(); track item.uuid) {
                            <tr>
                                <td>{{ item.paidAt | date:'dd/MM/yyyy' }}</td>
                                <td class="fw-bold">{{ item.request?.code || item.requestId }}</td>
                                <td>{{ item.party?.names ?? 'N/A' }}</td>
                                <td><span class="badge bg-light text-dark border">{{ item.entityCode }}</span></td>
                                <td class="text-end fw-semibold">${{ item.amount | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                            }
                            @if(pendingReimbursements().length === 0) {
                            <tr>
                                <td colspan="5" class="text-center text-muted py-3">No hay reembolsos pagados pendientes de contabilizar en este rango.</td>
                            </tr>
                            }
                        </tbody>
                        @if(pendingReimbursements().length > 0) {
                        <tfoot class="table-light fw-bold">
                            <tr>
                                <td colspan="4" class="text-uppercase text-muted">Total General Pagos</td>
                                <td class="text-end text-primary fs-6">${{ pendingReimbursementsTotal() | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                        </tfoot>
                        }
                    </table>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="d('Cancel')">Cerrar</button>
            @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
            <button class="btn btn-primary" [disabled]="pendingReimbursements().length === 0 || isPendingReimbursementsLoading()" (click)="exportReimbursementsOnly(modal)">
                <i class="fas fa-download me-1"></i> Exportar Excel (Copia)
            </button>
            }
            @if (perm.hasCurrentAction('ACCOUNT_REIMBURSEMENTS_UCH')) {
            <button class="btn btn-success" [disabled]="pendingReimbursements().length === 0 || isPendingReimbursementsLoading()" (click)="exportAndAccountReimbursements(modal)">
                <i class="fas fa-file-excel me-1"></i> Exportar y Contabilizar
            </button>
            }
        </div>
    </ng-template>

    <app-claim-informe-pdf />

